import { Row } from 'styled-bootstrap-grid';
import styled, { css } from 'styled-components';
import { Media } from '@/js/libs/ui';
import { Section } from '../Components/Section';
const groupSpacingStyles = css `
  @media ${Media.smMin} {
    gap: 24px 0;

    &:not(:last-child) {
      ${({ disabledSpacer }) => !disabledSpacer &&
    css `
          margin-bottom: 24px;
        `}
    }
  }

  @media ${Media.xsMax} {
    gap: 8px 0;

    &:not(:last-child) {
      ${({ disabledSpacer }) => !disabledSpacer &&
    css `
          margin-bottom: 8px;
        `}
    }
  }
`;
export const FormGroup = styled(Row) `
  ${groupSpacingStyles}
`;
export const InnerGroup = styled.div `
  ${groupSpacingStyles}
`;
export const LabelCompensationWrapper = styled.div `
  margin-top: 24px;
`;
const BaseFormLayout = styled.div `
  & + & {
    @media ${Media.mdMin} {
      margin-top: 24px;
    }
    @media ${Media.smMax} {
      margin-top: 8px;
    }
  }
`;
export const SplittedFormLayout = styled(BaseFormLayout) `
  display: grid;
  align-items: flex-start;
  @media ${Media.mdMin} {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  @media ${Media.smMax} {
    grid-template-columns: 1fr;
    gap: 8px;
  }
`;
export const VerticalFormLayout = styled(BaseFormLayout) `
  display: flex;
  flex-direction: column;
  @media ${Media.mdMin} {
    gap: 24px;
  }
  @media ${Media.smMax} {
    gap: 8px;
  }
`;
export const StandaloneSubmitSection = styled(Section) `
  padding: 16px 12px;
  @media ${Media.mdMin} {
    margin-top: 24px;
  }
  @media ${Media.smMax} {
    margin-top: 8px;
  }
`;
